import React from 'react';
import { IProductData } from 'interfaces/IProductData';
import { CurrencyFormat } from 'components/CurrencyFormat';
import { BaseComponent } from 'components/BaseComponent';

interface IPriceProps {
  cart: IProductData;
}

export default class Br extends BaseComponent<null, IPriceProps> {
  render() {
    const { price } = this.props.cart;
    const { cart } = this.props;

    if (cart.next) {
      return null;
    }

    return (
      <div className="chk-full">
        <span className="chk-full-price theme-label">
          <CurrencyFormat value={price} />
        </span>
        <div className="chk-small-price">
          <span> à vista </span>
        </div>
      </div>
    );
  }
}
